export default function (a, b) {
  return a = +a, b -= a, function (t) {
    return a + b * t;
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-interpolate@1.3.3@d3-interpolate/src/number.js
// module id = 372
// module chunks = 0